<template></template>
<script>
import { useToast } from 'vue-toastification';

export default {
  props: {
    on: { required: false },
    error: { type: Boolean, default: false },
    warning: { type: Boolean, default: false },
    message: { type: String, required: false },
  },

  methods: {
    showToast() {
      const toast = useToast();

      if (this.on) {
        if (this.error) toast.error(this.toastMessage);
        else if (this.warning) toast.warning(this.toastMessage);
        else toast.success(this.toastMessage);
      }
    },
  },
  mounted() {
    this.showToast();
  },
  computed: {
    toastMessage() {
      if (this.message) return this.message;
      return this.on;
    },
  },

  watch: {
    on(newVal) {
      if (newVal) {
        this.showToast();
      }
    },
  },
};
</script>
<style>
.Vue-Toastification__container.top-right {
  right: 2em !important;
  top: 5em !important;
}
.Vue-Toastification__toast {
  align-items: baseline !important;
  min-height: 55px !important;
  min-width: 235px !important;
  padding: 16px !important;
}
.Vue-Toastification__toast--success {
  background-color: #2dd4bf !important;
}
.Vue-Toastification__icon {
  margin: auto 10px auto 0 !important;
}
</style>
